module.exports = __webpack_public_path__ + "static/Solution-5753a4843680cf3d8e4ceda666758d42.png";